(function () {
  function refreshFreeShippingBars() {
    var currentBars = document.querySelectorAll('[data-vu-free-shipping]');
    if (!currentBars.length) return;

    fetch(window.location.pathname + window.location.search, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(res => res.text())
      .then(html => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        currentBars.forEach(function (currentBar) {
          var context = currentBar.getAttribute('data-vu-free-shipping-context');
          var newBar = doc.querySelector('[data-vu-free-shipping-context="' + context + '"]');

          if (newBar) {
            currentBar.replaceWith(newBar);
          }
        });
      })
      .catch(() => {});
  }

  document.addEventListener('cart:updated', () => {
    setTimeout(refreshFreeShippingBars, 250);
  });

  document.addEventListener('product:added', () => {
    setTimeout(refreshFreeShippingBars, 250);
  });

  document.addEventListener('click', () => {
    setTimeout(refreshFreeShippingBars, 300);
  });
})();